module.exports = __webpack_public_path__ + "img/marine_one-8.89876b94.png";